import { render, staticRenderFns } from "./imgtextnav.vue?vue&type=template&id=4428b3f0&scoped=true"
import script from "./imgtextnav.vue?vue&type=script&lang=js"
export * from "./imgtextnav.vue?vue&type=script&lang=js"
import style0 from "./imgtextnav.vue?vue&type=style&index=0&id=4428b3f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4428b3f0",
  null
  
)

component.options.__file = "imgtextnav.vue"
export default component.exports